/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgRefreshBranch = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M16 2a3 3 0 1 0 0 6v2a5 5 0 1 1 5-5v.586l1.293-1.293 1.414 1.414L20 9.414l-3.707-3.707 1.414-1.414L19 5.586V5a3 3 0 0 0-3-3z" />
        <path d="M16.486 12c-.533 1.404-1.432 2.43-2.454 3.182-1.343.988-2.918 1.509-4.185 1.718A4.008 4.008 0 0 0 7 14.126V2H5v12.126A4.002 4.002 0 0 0 6 22a4.002 4.002 0 0 0 3.895-3.085c1.576-.22 3.586-.844 5.322-2.122 1.486-1.092 2.756-2.655 3.377-4.793zM4 18a2 2 0 1 1 4 0 2 2 0 0 1-4 0z" />
      </g>
    </g>
  </Icon>
);
export { SvgRefreshBranch as RefreshBranch };
